import { render, staticRenderFns } from "./DetalleAbono.vue?vue&type=template&id=03ace5b6"
import script from "./DetalleAbono.vue?vue&type=script&lang=js"
export * from "./DetalleAbono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports